// Versão: 1.01
// Data..: 2026-09-26
// Gráfico de barras horizontais simples (sem dependências externas).
// v1.01: barra opcionalmente clicável (onBarClick) — usada para drill-down do
// painel gerencial até a lista de chamados filtrada.

interface BarDatum {
  label: string;
  value: number;
  color?: string;
  // Chave opaca opcional repassada ao onBarClick (ex.: id da empresa/categoria);
  // quando ausente, o onBarClick recebe o próprio label.
  key?: string;
}

interface BarChartProps {
  data: BarDatum[];
  emptyText?: string;
  // Quando informado, cada barra vira clicável e chama isto com key ?? label.
  onBarClick?: (key: string, datum: BarDatum) => void;
}

export function BarChart({ data, emptyText = 'Sem dados', onBarClick }: BarChartProps) {
  const max = Math.max(1, ...data.map((d) => d.value));
  if (data.length === 0 || data.every((d) => d.value === 0)) {
    return <div className="text-dim text-sm" style={{ padding: '12px 0' }}>{emptyText}</div>;
  }
  return (
    <div className="flex flex-col gap-3">
      {data.map((d) => {
        const clickable = !!onBarClick;
        const activate = () => onBarClick?.(d.key ?? d.label, d);
        return (
          <div
            key={d.label}
            onClick={clickable ? activate : undefined}
            onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); } } : undefined}
            role={clickable ? 'button' : undefined}
            tabIndex={clickable ? 0 : undefined}
            title={clickable ? `Ver chamados: ${d.label}` : undefined}
            style={clickable ? { cursor: 'pointer' } : undefined}
          >
            <div className="flex items-center justify-between text-sm" style={{ marginBottom: 4 }}>
              <span className="text-muted">{d.label}</span>
              <span className="font-semibold">{d.value}</span>
            </div>
            <div style={{ height: 8, background: 'var(--surface-3)', borderRadius: 999, overflow: 'hidden' }}>
              <div
                style={{
                  width: `${(d.value / max) * 100}%`,
                  height: '100%',
                  background: d.color ?? 'var(--brand)',
                  borderRadius: 999,
                  transition: 'width 0.4s ease',
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
